import React from "react";
import { cn } from "../../lib/cn";

export function Space({ children, size = 8, direction = "horizontal", className }) {
  const gap = typeof size === "number" ? size : 8;
  return (
    <div
      className={cn(
        direction === "vertical" ? "flex flex-col" : "flex flex-wrap items-center",
        className
      )}
      style={{ gap }}
    >
      {children}
    </div>
  );
}
